<template>
    <div class="card border p-mt-3 p-mb-3">

        <div class="card-body py-3 bg-transparent">

            <h3 class="p-card-title small font-weight-500" v-if="header" :class="classesTitle" style="min-height: 20px;">

                <checkbox v-if="showCheckbox" style="position: relative; top: 3px; left: 0;" type="checkbox"
                          :id="checkOptions.id" v-model="checkOptions.model" @change="changeEvent()"/>

                {{header}}

                <toggle :show="show" @change="show = $event" :key="pKey" v-if="pKey"
                        class="ml-1 text-muted float-right" />

                <slot name="actions" class="small"></slot>
                <slot name="description" class="w-100"></slot>

            </h3>

            <div v-if="!pKey || show" class="p-grid" :style="!header ? {'padding-top': '1rem'} : ''">
                <slot></slot>
            </div>

        </div>

    </div>
</template>

<script>
    import Toggle from "@/components/card/Toggle";
    
    export default {
        name: "Card",
        components: {Toggle},
        props:{
            pKey : String,
            header: String,
            checkOptions : {},
            noBorder : Boolean,
            classTitle : String
        },
        data(){
            return {
                show : true
            }
        },
        computed: {
            showCheckbox() {
                return this.checkOptions && Object.keys(this.checkOptions)?.length
            },
            classesTitle(){
                let c = 'border-bottom pb-1 ';
                if(this.noBorder || !this.show) c = 'pb-0 mb-0 ';
                if(this.classTitle) c += this.classTitle;
                return c
            }
        },
        methods: {
            changeEvent() {
                this.$emit('change-check', this.checkOptions);
            },
        }
    }
</script>

<style scoped>
    .card{
        padding-top: 1px;
        background-color: transparent;
    }
</style>
